import { FC } from 'react'
import { Box, useTheme } from '@mui/material'
import { Icon } from 'packages/eid-icons'
import { EidButton, Tooltip } from 'packages/eid-ui'
import { Instructions } from 'components/ApplicationBanner/Instructions'
import { useTranslation } from 'react-i18next'
import Button from './Button'

export interface IResourceListingInfoIconProps {
    attribute: any
    data: any
    isCardView?: boolean
}

export const ResourceListingInfoIcon: FC<IResourceListingInfoIconProps> = (
    props,
) => {
    const theme = useTheme()

    const { t } = useTranslation()

    const { data, isCardView } = props

    const getTooltipTitle = () => t('Common_MoreInfo')
    return (
        <>
            {data && data.instructions && (
                <Box
                    sx={
                        isCardView
                            ? {
                                position: 'relative',
                                width: '100%',
                            }
                            : {
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                width: '40px',
                                minHeight: '32px',
                                paddingTop: '4px',
                                paddingBottom: '4px',
                                marginBottom: '35px',
                            }
                    }
                >
                    <Instructions
                        title={data.friendlyName}
                        instructions={data.instructions}
                        button={(onClick: any) => {
                            return !isCardView ? (
                                <Tooltip title={getTooltipTitle()} tabIndex={0}>
                                    <EidButton
                                        title={t('Common_MoreInfo')}
                                        onClick={() => onClick(true)}
                                    >
                                        <Icon
                                            name="Info"
                                            color={theme?.palette?.grey?.[900]}
                                            width="24px"
                                            height="25px"
                                        />
                                    </EidButton>
                                </Tooltip>
                            ) : (
                                <Button
                                    title={t('Common_MoreInfo')}
                                    onClick={() => onClick(true)}
                                />
                            )
                        }}
                    />
                </Box>
            )}
        </>
    )
}
